//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PayPalCommercePlatformPartnerReferralLinkType } from './Enums';

export class PayPalCommercePlatformPartnerReferralInputItem extends ItemBase {
    EmailAddress: string | null = null;
    ReturnUrl: string | null = null;
    LinkType: PayPalCommercePlatformPartnerReferralLinkType = PayPalCommercePlatformPartnerReferralLinkType.Express;

    constructor(initializer?: Partial<PayPalCommercePlatformPartnerReferralInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PayPalCommercePlatformPartnerReferralInputItem";
}
